var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{class:_vm.componentClass,attrs:{"title":_vm.metaTitle,"noContainer":true}},[_c('div',[_c('v-container',{staticClass:"py-15"},[(!_vm.smAndDown)?_c('v-row',{staticClass:"mt-5",attrs:{"justify":"center"}},_vm._l((_vm.items),function(item,key){return _c('v-col',{key:key,attrs:{"cols":"6","md":"3"}},[_c('ServiceCard',{attrs:{"item":item}})],1)}),1):_vm._e(),(_vm.items.length && _vm.smAndDown)?_c('CarouselWidget',{staticClass:"my-10",attrs:{"items":_vm.items,"itemsToShow":{
          xs: 1.2,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 3,
        },"gap":20,"dots":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
        var item = ref.item;
return [_c('ServiceCard',{attrs:{"item":item}})]}}],null,false,2142692583)}):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }